import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitControlSelectListModel } from '@apps-common/types/portal/unit-control'

export const QUERY_KEY_PORTAL_GET_UNIT_CONTROL_SELECT_LIST_WITH_STATE = (unitId?: string) =>
  ['getUnitControlSelectList', unitId].filter(Boolean)

const getUnitControlSelectList = async (unitId: string): Promise<IUnitControlSelectListModel[]> =>
  axios.get(`/unitcontrol/getcontrolsselectlist?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitControlSelectList

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useGetUnitControlSelectList = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_PORTAL_GET_UNIT_CONTROL_SELECT_LIST_WITH_STATE(unitId),
    queryFn: () => getUnitControlSelectList(unitId)
  })
